import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const FREE_MARKETING_TEXTS = 50;

const DefaultList = () => {
  const { t } = useTranslation();

  return (
    <ul>
      <li>✔</li>
      <li>✔</li>
      <li>✔</li>
      <li>✔</li>
      <li>✖</li>
      <li>✖</li>
      <li>✔</li>
      <li>✔</li>
      <li>✔</li>
      <li>✔</li>
      <li>{t('staffAndBusiness.subAndBilling.pricePlan.unlimitedDevicesLogins')}</li>
      <li>✔</li>
      <li>✔ {t('staffAndBusiness.subAndBilling.pricePlan.unlimited')}</li>
      <li>-</li>
      <li>{FREE_MARKETING_TEXTS}</li>
    </ul>
  );
};

export default DefaultList;
